import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Rules = () => {
    // Scroll to the top when the component mounts
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const appName = "منصة طفلي المبدع";
    const effectiveDate = "15 نوفمبر 2025";

    return (
        <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8" dir="rtl">
            <header className="text-center mb-10">
                <h1 className="text-4xl font-extrabold text-red-700 sm:text-5xl border-b-4 border-red-200 pb-3">
                    قواعد وشروط الاستخدام
                </h1>
                <p className="mt-4 text-gray-600 text-lg">
                    تاريخ السريان: {effectiveDate}
                </p>
            </header>

            <section className="space-y-8 text-gray-700">
                {/* --- 1. قبول الشروط --- */}
                <div className="p-6 bg-white rounded-xl shadow-lg border-r-4 border-red-500">
                    <h2 className="text-2xl font-bold mb-3 text-red-600">
                        1. قبول الشروط
                    </h2>
                    <p>
                        باستخدامك لخدمات **{appName}**، فإنك توافق على الالتزام بشروط وأحكام الاستخدام هذه. إذا كنت لا توافق على هذه الشروط، فيرجى عدم استخدام التطبيق. هذه الشروط تنطبق على جميع المستخدمين والزوار الذين يصلون إلى أو يستخدمون الخدمة.
                    </p>
                </div>

                {/* --- 2. حقوق الملكية الفكرية --- */}
                <div className="p-6 bg-white rounded-xl shadow-lg border-r-4 border-red-500">
                    <h2 className="text-2xl font-bold mb-3 text-red-600">
                        2. حقوق الملكية الفكرية
                    </h2>
                    <p className="mb-3">
                        جميع المحتويات الموجودة في **{appName}**، بما في ذلك النصوص، الرسومات، الشعار، والدروس، هي ملكية خاصة لـ **{appName}** أو مرخصة لنا، وهي محمية بموجب قوانين حقوق النشر والملكية الفكرية.
                    </p>
                    <ul className="list-disc pr-6 space-y-2">
                        <li>
                            **الاستخدام المقبول:** يُسمح باستخدام المحتوى لأغراض تعليمية وشخصية وغير تجارية فقط.
                        </li>
                        <li>
                            **الحظر:** يُحظر تماماً نسخ أو إعادة إنتاج أو توزيع أو تعديل أي جزء من محتوى التطبيق دون إذن كتابي مسبق.
                        </li>
                    </ul>
                </div>

                {/* --- 3. سلوك المستخدم --- */}
                <div className="p-6 bg-white rounded-xl shadow-lg border-r-4 border-red-500">
                    <h2 className="text-2xl font-bold mb-3 text-red-600">
                        3. سلوك المستخدم
                    </h2>
                    <p>
                        يجب على المستخدمين الالتزام بجميع القوانين واللوائح المعمول بها عند استخدام التطبيق.
                    </p>
                    <ul className="list-disc pr-6 space-y-2">
                        <li>
                            **النزاهة:** يُمنع محاولة الوصول غير المصرح به إلى أي جزء من التطبيق أو الخوادم الخاصة بنا.
                        </li>
                        <li>
                            **الاحترام:** يُمنع نشر أي محتوى مسيء، غير قانوني، أو ضار، أو أي محتوى ينتهك حقوق الآخرين.
                        </li>
                    </ul>
                </div>

                {/* --- 4. إخلاء المسؤولية --- */}
                <div className="p-6 bg-white rounded-xl shadow-lg border-r-4 border-red-500">
                    <h2 className="text-2xl font-bold mb-3 text-red-600">
                        4. إخلاء المسؤولية
                    </h2>
                    <p>
                        يتم توفير خدمات **{appName}** على أساس "كما هي" دون أي ضمانات من أي نوع، صريحة أو ضمنية. نحن لا نضمن أن الخدمة ستكون خالية من الأخطاء أو أنها ستعمل دون انقطاع.
                    </p>
                </div>

                {/* --- 5. الاتصال بنا --- */}
                <div className="p-6 bg-white rounded-xl shadow-lg border-r-4 border-red-500">
                    <h2 className="text-2xl font-bold mb-3 text-red-600">
                        5. الاتصال بنا
                    </h2>
                    <p>
                        للاستفسار عن شروط الاستخدام، يرجى التواصل معنا عبر:
                    </p>
                    <p className="mt-2 font-mono bg-gray-100 p-2 rounded">
                       omran4d@gmail.com
                    </p>
                </div>

                {/* --- Footer Link --- */}
                <div className="text-center pt-4">
                    <Link to="/" className="text-red-500 hover:text-red-700 font-bold transition-colors">
                        العودة إلى الصفحة الرئيسية 🏠
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Rules;